export default "__VITE_ASSET__CRuB0hLE__"